import {ValueObject} from '@s-ui/domain'

export class GetSellerRequest extends ValueObject {
  /**
   * @param {Object} param
   * @param {Number|String} param.contractId
   * @param {Number|String} param.userId
   * @param {Boolean} param.isDealer
   * @param {Boolean} param.isPrivate
   */

  static validate({contractId, userId, invalidSellerRequestSellerError}) {
    if (!contractId && !userId) throw invalidSellerRequestSellerError('contractId or userId are required')
  }

  isDealer() {
    return this._isDealer
  }

  isPrivate() {
    return this._isPrivate
  }
}
